import { api, refreshFileToken } from "@/lib/api";

// Export ke stažení (PDF / XLSX / CSV) — zadání 217. Na rozdíl od downloadSigned (jen klikne
// na <a href>) se soubor stáhne jako blob, takže víme, kdy export doběhl a jestli se povedl:
// tlačítko může být mezitím zakázané a chyba skončí hláškou, ne staženým JSONem nebo
// přesměrováním celé záložky mimo aplikaci.

// Název z Content-Disposition (filename*=UTF-8''… má přednost). Hlavičku prohlížeč ukáže
// jen u stejného originu — jinak null a použije se název od volajícího.
export function filenameFromDisposition(cd) {
  if (!cd) return null;
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(cd);
  if (star) {
    try { return decodeURIComponent(star[1].trim().replace(/^"|"$/g, "")); } catch { /* spadne na filename= */ }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(cd);
  return plain ? plain[1].trim() : null;
}

// Blob.text() chybí ve starším Safari (< 14) — záloha přes FileReader.
function blobText(b) {
  if (typeof b.text === "function") return b.text();
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = () => reject(r.error);
    r.readAsText(b);
  });
}

// U responseType "blob" přijde i chybové tělo jako Blob — přečíst ho, ať apiError ukáže `detail`.
export async function blobErrorToJson(err) {
  const d = err?.response?.data;
  if (typeof Blob !== "undefined" && d instanceof Blob) {
    try {
      const t = await blobText(d);
      try { err.response.data = JSON.parse(t); } catch { err.response.data = t; }
    } catch { /* nechat, jak je */ }
  }
  return err;
}

export function saveBlob(blob, filename) {
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 60_000);
}

// path jako u downloadSigned („/api/…"), filename je záloha, když hlavička není vidět.
export async function downloadExport(path, filename) {
  const sig = await refreshFileToken(true);
  const sep = path.includes("?") ? "&" : "?";
  const rel = path.replace(/^\/api(?=\/)/, "");
  try {
    const res = await api.get(`${rel}${sep}sig=${encodeURIComponent(sig || "")}`, { responseType: "blob" });
    const name = filenameFromDisposition(res.headers?.["content-disposition"]) || filename || "export";
    saveBlob(res.data, name);
    return name;
  } catch (err) {
    throw await blobErrorToJson(err);
  }
}
